import {SxProps, Theme} from '@mui/material';
import {actionButtonSx} from 'src/components/common/actionButton.sx';

/** Advancing the contract is the primary thing this page offers, so it wears the primary tone. */
export const moveToOperationButtonSx: SxProps<Theme> = {
    ...(actionButtonSx('32px') as object),
    width: 'max-content',
};
